import React from 'react';
import { motion } from 'framer-motion';
export function CostComparison() {
  const costs = [{
    sin: '3 horas semanales buscando prompts que no funcionan',
    real: '150 horas de tu vida por año'
  }, {
    sin: 'Resultados genéricos que reescribís igual',
    real: 'Doble trabajo, mitad de impacto'
  }, {
    sin: 'Sin sistema de verificación de datos',
    real: 'Errores frente a clientes o público'
  }, {
    sin: 'Contenido que parece IA y nadie comparte',
    real: 'Algoritmo que te entierra'
  }, {
    sin: 'Tareas que siguen tardando horas "con IA"',
    real: 'La IA no te ahorra tiempo sin el flujo correcto'
  }, {
    sin: 'Semana tras semana el mismo ciclo',
    real: 'El próximo año en las mismas'
  }];
  return <section className="py-20 px-4" data-id="element-37">
      <div className="max-w-4xl mx-auto" data-id="element-38">
        <div className="text-center mb-12" data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white" data-id="element-40">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="bg-surface border border-border rounded-2xl overflow-hidden mb-12" data-id="element-41">
          <table className="w-full border-collapse" data-id="element-42">
            <thead data-id="element-43">
              <tr className="bg-background border-b border-border" data-id="element-44">
                <th className="text-left py-4 px-6 text-white font-medium w-1/2" data-id="element-45">
                  Sin MegaPack IA
                </th>
                <th className="text-left py-4 px-6 text-danger font-medium w-1/2" data-id="element-46">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-47">
              {costs.map((row, idx) => <tr key={idx} className="border-b border-border/50 last:border-0 hover:bg-white/5 transition-colors" data-id="element-48">
                  <td className="py-4 px-6 text-gray-300" data-id="element-49">{row.sin}</td>
                  <td className="py-4 px-6 text-danger/90 font-medium" data-id="element-50">
                    {row.real}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center" data-id="element-51">
          <p className="text-xl text-muted mb-8" data-id="element-52">
            El próximo lunes puede ser diferente.
          </p>
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block bg-brand/10 border border-brand/30 rounded-2xl p-8" data-id="element-53">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white italic" data-id="element-54">
              "El próximo lunes puede ser diferente."{' '}
              <span className="not-italic" data-id="element-55">🤖</span>
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}